import React from 'react';
import { useSelector } from 'react-redux';
import Team from './Team'
import './TeamList.css';
import ColorLegend from '../planning/ColorLegend';
import * as ResourceStore from '../../store/ResourceStore';
import moment from 'moment';

const CustomTeamList = () => {
    const units = useSelector((state) => state[ResourceStore.reducerName].units);
    const bookings = useSelector((state) => state[ResourceStore.reducerName].bookings);
    const teams = useSelector((state) => state.teamState.teams);

    const now = moment();
    const currentBookings = bookings.filter((x) => now.isSameOrAfter(moment(x.startTime)) && now.isSameOrBefore(moment(x.endTime)));

    if(teams.length < 1) return null;

    const addUnits = (team) => {
        if (!team) return;
        const unitsForTeam = currentBookings.reduce((result, b) => {
            if (b.teamId === team.id) {
                const unit = units.find((u) => u.id === b.unitId);
                if (unit) result.push(unit);
            }
            return result;
        }, []);
        return { ...team, units: unitsForTeam };
    };

    const administration = teams.find(x => x.id === 130);
    addUnits(administration);
    const vejomraadet = teams.find(x => x.id === 132);
    addUnits(vejomraadet);
    const parkomraadet = teams.find(x => x.id === 133);
    addUnits(parkomraadet);
    const vaerksted = teams.find(x => x.id === 131);
    addUnits(vaerksted);

    return (
        <div className="team-list" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div className='admin-vej-wrapper' style={{ display: 'flex', flexDirection: 'row', height: '63%' }}>
                {administration &&
                    <Team
                        team={administration}
                        width={50}
                        // height={100}
                        paddingBottom={0.2}
                        subTeams={[vaerksted]}
                    />
                }
                {vejomraadet && 
                    <Team 
                        team={vejomraadet} 
                        width={50}
                        // height={40}
                        paddingBottom={0.2}
                    />
                }
            </div>
            {parkomraadet &&
                <Team 
                    team={parkomraadet} 
                    // width={50}
                    height={37}
                    paddingBottom={3}
                />
            }
            <ColorLegend />
        </div>
    );
};

export default CustomTeamList;